import { render, staticRenderFns } from "./PlatformOwner.vue?vue&type=template&id=3fbcdc34&scoped=true"
import script from "./PlatformOwner.vue?vue&type=script&lang=js"
export * from "./PlatformOwner.vue?vue&type=script&lang=js"
import style0 from "./PlatformOwner.vue?vue&type=style&index=0&id=3fbcdc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcdc34",
  null
  
)

export default component.exports